import { msg } from '@lingui/macro';

/**
 * Shared by `:id` and `:id/:subtab` — the same detail page under both shapes.
 *
 * `handle.header` (DL-63992) puts the style breadcrumb in the global topbar in place
 * of the list title; see `docs/routing.md` (Route `handle`). Both the component and
 * the handle come back from `lazy()` so the header stays in this route's chunk
 * instead of being statically imported into the main bundle.
 */
const loadDetailRoute = async () => {
  const [{ Details }, { StyleV2TopbarHeader }] = await Promise.all([
    import('../pages/style-v2'),
    import('../features/styles-v2/components/StyleV2TopbarHeader'),
  ]);
  return {
    Component: Details,
    handle: {
      name: 'Style v2 details',
      category: 'Style',
      header: StyleV2TopbarHeader,
      topbarBackground: 'primary',
    },
  };
};

/**
 * New-model Styles v2 prototype routes (DL-62519) — mock-only, on their own
 * `/style-v2` namespace so the existing `/style` routes stay frozen. The detail
 * page is addressed by `:id` with an optional `:subtab` segment (the default tab
 * resolves at bare `/style-v2/:id`), mirroring the existing style-detail routing.
 */
export const StyleV2Routes = {
  path: 'style-v2',
  async lazy() {
    const { Parent } = await import('../pages/style-v2');
    return { Component: Parent };
  },
  handle: { name: 'Styles v2 list', category: 'Styles', title: msg`Styles (v2)` },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('../pages/style-v2');
        return { Component: Index };
      },
    },
    {
      path: ':id',
      lazy: loadDetailRoute,
    },
    {
      path: ':id/:subtab',
      lazy: loadDetailRoute,
    },
  ],
};
